import axios from 'axios'
import { Toast } from 'vant'

const baseURL = process.env.NODE_ENV === 'development' ? '/api' : 'http://jwsxgc.suchengkeji.cn/jiawangsanxiang/api/'
// const baseURL = process.env.NODE_ENV === 'development' ? '/api' : 'https://lib.xzdckj.cn/jiawangsanxiang/api/'


const service = axios.create({
  baseURL,
  timeout: 20000
})

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

Toast.setDefaultOptions({
  duration: 1500
})

let toast

service.interceptors.request.use(
  (config) => {
    toast && toast.clear()
    if (!config.headers['No-Loading']) {
      toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '加载中'
      })
    }
    return config
  },
  (error) => {
    toast && toast.clear()
    Toast('网络开小差了，请稍后重试')
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    toast && toast.clear()
    if (response.status === 200) {
      const data = response.data
      if (data.state !== 200) {
        // Toast(data.message)
      }
      return data
    }
  },
  (error) => {
    toast && toast.clear()
    Toast('网络开小差了，请稍后重试')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js